<template>
  <div id="kimia" class="kimia">
    <Head class="kimia__content" />
    <Footer class="kimia__footer" />
  </div>
</template>

<script>
import Head from './components/Content.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Head,
    Footer,
  }
}
</script>

<style lang="sass">
@import "@/styles/base.sass"

.kimia
  display: grid
  height: 95vh
  grid-template-areas: "content" "footer"
  grid-template-rows: auto 50px
  min-width: 320px
  min-height: 500px
  &__content
    grid-area: content
    margin: auto
  &__footer
    grid-area: footer
</style>
